import { useCallback } from "react"

import type { PanelProps } from "../panel-props"

import { useDatabaseLength } from "../../../modules/database-length-store"
import { useSettings } from "../../../modules/settings"
import { Badge } from "../../badge"
import { Slider } from "../../slider"
import { SharedSettings } from "../shared-settings"

export function TranslateItSettings(input: PanelProps) {
  const {
    appSettings: { index },
    setIndexInStorage,
  } = useSettings()
  const databaseLength = useDatabaseLength()
  const currentIndex = index.translateIt ?? 0
  const memoizedSetIndexInStorage = useCallback(setIndexInStorage, [])

  const onSliderValueChange = (newIndex: number)=> {
    memoizedSetIndexInStorage("translateIt", newIndex)
  }
  const step = Math.floor(databaseLength / 100) || 1

  return (
    <SharedSettings closeSidebar={input.closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Position</h3>
        <div>
          index <Badge value={String(currentIndex)} /> from{" "}
          <Badge value={String(databaseLength - 1)} />
        </div>
        <Slider
          label="Index"
          max={databaseLength - 1}
          min={0}
          onValueChange={onSliderValueChange}
          step={step}
          value={currentIndex}
        />
      </section>
    </SharedSettings>
  )
}
